import React from 'react';
import { Link } from 'react-router-dom';
import { Target, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { Button } from './ui/Button';
export function Cap360() {
  return <Card className="border-none shadow-lg bg-primary-dark text-white overflow-hidden relative" data-id="element-40" data-mp="smzs6j97mhnb">
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary rounded-full blur-[80px] opacity-30 pointer-events-none" data-id="element-41" data-mp="xm3zt5ghk7bj" />
      <CardContent className="p-8 md:p-10 relative z-10" data-id="element-42" data-mp="1lb5cj4wcq4mm">
        <div className="flex items-center gap-3 mb-4" data-id="element-43" data-mp="1qa86nuasmqft">
          <div className="w-14 h-14 bg-white/10 rounded-2xl flex items-center justify-center shrink-0" data-id="element-44" data-mp="1qbt17jx3y9do">
            <Target className="w-7 h-7 text-lavande" data-id="element-45" data-mp="1bipsm21hv5z3" />
          </div>
          <div data-id="element-46" data-mp="1gic8kj8pj0bl">
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-brand-orange mb-1" data-id="element-47" data-mp="1gi2dwicpw4zk">
              Dispositif d'accompagnement
            </span>
            <h3 className="font-extrabold font-heading text-2xl text-white leading-tight" data-id="element-48" data-mp="290zpdmgo7t6v">
              CAP 360
            </h3>
          </div>
        </div>
        <p className="text-lavande text-lg leading-relaxed mb-6" data-id="element-49" data-mp="1znh15ycuxv8h">
          Pas encore d'entreprise ? Pas d'inquiétude. Avec CAP 360, nous
          accompagnons chaque jeune dans sa recherche d'alternance : préparation
          du CV et de la lettre de motivation, entraînement aux entretiens, mise
          en relation avec notre réseau d'entreprises partenaires et suivi
          personnalisé jusqu'à la signature du contrat.
        </p>
        <Button size="lg" className="group bg-white hover:bg-lavande text-primary-dark font-bold shadow-md" asChild data-id="element-50" data-mp="2icx40sc0lzs2">
          <Link to="/candidater#cap-360-section" className="flex items-center" data-id="element-51" data-mp="2sc5tp8zuks8m">
            Découvrir CAP 360
            <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-52" data-mp="11yx6tp4k0o8i" />
          </Link>
        </Button>
      </CardContent>
    </Card>;
}